export default class UpcomingEvent {
    public id: number;
    public type: string;
    public startTime: string;
    public title: string;
    public image: string;
    public attending: boolean;
    public notificationId: number;

    constructor(
        id: number,
        type: string,
        startTime: string,
        title: string,
        image: string,
        attending: boolean = false,
        notificationId: number = null,
    ) {
        this.id             = id;
        this.type           = type;
        this.startTime      = startTime;
        this.title          = title;
        this.image          = image;
        this.attending      = attending;
        this.notificationId = notificationId;
    }

    get isEvent(): boolean {
        return this.type === 'event';
    }

    get isBooking(): boolean {
        return this.type === 'booking';
    }

    public changeAttending(status: boolean): void {
        this.attending = status;
    }
}
